import "./Header.css"
import Furkan from "./furkan-logo.png"

const Header = () => {
  return (
    <header>
      <nav>
        <img src={Furkan} alt="Furkan" />
      </nav>
        
    </header>
    
  )
}

export default Header